import React from 'react';
import { Grid } from '@ui-propulsion/react-components';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import CtaButton from '../../ctaButton/ctaButton';
import styles from './commonTableDesktop.module.scss';
import handleCTAClick from '../../../services/helpers/handleCTAClick';

export default function CommonTableDesktop({
  title = '',
  description = '',
  tableHeader = [],
  tableData = [],
  cta = null,
}) {
  return (
    <section className={styles.tableContainer}>
      <Grid container>
        <Grid item container xs={12} justifyContent="center">
          {title && <h2 className={styles.title}>{title}</h2>}
        </Grid>
        <Grid item container xs={12} justifyContent="center">
          <div className={styles.commonTable}>
            <table>
              <tbody>
                <tr>
                  {tableHeader?.map((item, index) => {
                    const key = `tablehead-${index}`;
                    return <th key={key}>{parse(item)}</th>;
                  })}
                </tr>
                {tableData?.map((item, index) => {
                  const key = `table-${index}`;
                  return (
                    <tr key={key}>
                      {item?.rows?.map((value, i) => {
                        const id = `table-${i}`;
                        return (
                          <td key={id}>
                            {value.value ? parse(value.value) : ''}
                            {value.cta && (
                              <div className={styles.ctaWrapper}>
                                <CtaButton
                                  aria-label={value.cta.label}
                                  data-testid={`${value.cta.label}-${index}-${i}`}
                                  label={value.cta.label}
                                  color={value.cta.color}
                                  variant={value.cta.variant}
                                  fullWidth
                                  href={value.cta.link}
                                  onClick={(e) => handleCTAClick(e, value.cta)}
                                />
                              </div>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Grid>
        <Grid item container xs={12} justifyContent="center">
          <div className={styles.description}>{parse(`${description}`)}</div>
        </Grid>
        {cta && (
          <Grid item container xs={12} justifyContent="center">
            <CtaButton
              label={cta.label}
              variant={cta.variant}
              color={cta.color}
              className={styles.cta}
              href={cta.link}
            />
          </Grid>
        )}
      </Grid>
    </section>
  );
}

CommonTableDesktop.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  cta: PropTypes.shape({
    link: PropTypes.string,
    label: PropTypes.string,
  }),
  tableHeader: PropTypes.array,
  tableData: PropTypes.array,
};
